import { useRef, useEffect } from "react";
import { useNavigate } from 'react-router-dom'
import { useDispatch } from "react-redux"
import { Box } from "@mui/material";
import Typography from '@mui/material/Typography';
import Backdrop from '@mui/material/Backdrop';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import { useLogoutMutation } from '../features/auth/authApiSlice'
import { setPBIReportList, setSelectedReportDetails, setSelectedReportId, setTenantWorkspace, setTenantWorkspacelist } from '../features/auth/authSlice'

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
  };
const Logout = ({ openLogout, handleLogoutClose }) => {

  const dispatch = useDispatch()

  const buttonInput = useRef(null);
  const navigate = useNavigate()
  const [logout, { isLoading }] = useLogoutMutation()

  useEffect(() => {
    if (buttonInput.current) {
      buttonInput.current.focus();
    }
  });

  const handleLogout = async () => {
    let emptyreports = [];
    try {
        const userData = await logout().unwrap();
        localStorage.removeItem('userData');
        sessionStorage.removeItem('sessionStartTime');
        dispatch(setPBIReportList(emptyreports))
        dispatch(setSelectedReportDetails(null))
        dispatch(setSelectedReportId(null))
        dispatch(setTenantWorkspace(null))
        dispatch(setTenantWorkspacelist([]))
        localStorage.removeItem('userData');
        sessionStorage.removeItem('sessionStartTime');
        navigate('/')
    } catch (err) {
      //For Login Bypass local development - Starts
        // dispatch(setPBIReportList(emptyreports))
        // dispatch(setSelectedReportDetails(null))
        // dispatch(setSelectedReportId(null))
        // dispatch(setTenantWorkspace(null))
        // dispatch(setTenantWorkspacelist([]))
        // window.location.reload();
        // navigate('/')
        //For Login Bypass local development - Ends
        if (!err?.originalStatus) {
          console.log(err);
        }
    }
  }

  return (
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={openLogout}
        onClose={handleLogoutClose}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={openLogout}>
          <Box sx={style}>
            <Typography id="transition-modal-title" variant="h6" component="h2">
            Confirmation
            </Typography>
            <Typography id="transition-modal-description" sx={{ mt: 2 }}>
            Are you sure you want to log out?
            </Typography>
            <Stack className="divlogoutbtn" direction="row" spacing={2}>
              <Button onClick={handleLogout} variant="contained" color="primary" ref={buttonInput} autoFocus>Confirm</Button>
              <Button variant="outlined" color="primary" onClick={handleLogoutClose}>Cancel</Button>
            </Stack>
          </Box>
        </Fade>
      </Modal>
  );
};

export default Logout;
